export default configuration => {
  if (!window._genesys) window._genesys = {};
  if (!window._gt) window._gt = [];

  window._genesys.widgets = {
    main: {
      debug: true,
      theme: 'dark',
      i18n: '/content/resources/js/chatGenesys/i18n-fr.json',
      lang: 'fr',
      customStylesheetID: 'genesys_widgets_custom',
      plugins: ['cx-webchat', 'cx-webchat-service', 'cx-gwe'],
    },
    webchat: {
      dataURL: configuration.webChatUrl,
      apikey: '',
      userData: { PRODUIT: configuration.productLabel },
      autoInvite: {
        enabled: false,
        timeToInviteSeconds: 5,
        inviteTimeoutSeconds: configuration.env === 'PRODUCTION' ? 30 : 500,
      },
      chatButton: {
        enabled: configuration.env === 'PRODUCTION' ? false : true,
        openDelay: 1000,
        effectDuration: 1000,
        hideDuringInvite: true,
      },
      confirmFormCloseEnabled: false,
      debug: true,
    },
    gwe: {
      httpsEndpoint: configuration.gweEndpoint,
      dslResource: configuration.gweDsl,
      debug: false,
    },
  };

  (function (o) {
    const d = o.location;
    const f = function () {
        o.aTags = o.aTags || [];
        for (let i = 0; i < o.aTags.length; i++) {
          const oTag = o.aTags[i];
          const fs = d.getElementsByTagName(oTag.type)[0];
          /* eslint-disable prefer-const */
          let e;
          if (d.getElementById(oTag.id)) return;
          e = d.createElement(oTag.type);
          e.id = oTag.id;

          if (oTag.type === 'script') {
            e.src = oTag.path;
          } else {
            e.type = 'text/css';
            e.rel = 'stylesheet';
            e.href = oTag.path;
          }
          if (fs) {
            fs.parentNode.insertBefore(e, fs);
          } else {
            d.head.appendChild(e);
          }
        }
      },
      ol = window.onload;
    if (o.onload) {
      typeof window.onload !== 'function'
        ? (window.onload = f)
        : (window.onload = function () {
            ol();
            f();
            // showConfigData();
          });
    } else {
      f();
    }
  })({
    location: document,
    onload: false,
    aTags: [
      { type: 'script', id: 'genesys-widgets-script', path: '/content/resources/js/chatGenesys/widgets.min.js' },
      { type: 'link', id: 'genesys-widgets-styles', path: '/content/resources/css/widgets.min.css' },
      { type: 'link', id: 'genesys-custom-styles', path: '/content/resources/css/widgets.custom_SPB.css' },
    ],
  });

  function launchRating() {
    const _url_enquete_satisfaction = '/content/resources/js/chatGenesys/NotationChat.html';
    const messageBox = document.querySelectorAll('.cx-body')[0];
    if (messageBox !== undefined) {
      const display = true;
      const nb = messageBox.children.length;
    }
    const iframe = document.createElement('iframe');
    iframe.src = _url_enquete_satisfaction;
    iframe.width = '100%';
    iframe.height = '57px;';
    iframe.id = 'iframe_rating';
    messageBox.appendChild(iframe);
  }

  window._genesys.widgets.onReady = function eventManager() {
    const widgetBus = window._genesys.widgets.bus;

    widgetBus.subscribe('cx.plugin.WebChatService.clientConnected', function (chatApi) {
      launchRating();
    });
  };

  function receiveMessage(event) {
    const widgetBus = window._genesys.widgets.bus;
    if (event.data === '0' || event.data === '1') {
      widgetBus
        .command('cx.plugin.WebChatService.updateUserData', {
          NotationChat: event.data,
        })
        .done(function (e) {
          document.querySelector('#iframe_rating').display = 'none';
        })
        .fail(function (e) {
          console.log('updateUserData failed');
        });
    }
  }

  window.addEventListener('message', receiveMessage, false);
};
